module.exports = __webpack_public_path__ + "static/2-7efd4353d354c166a03a61f1ecb23138.jpg";